import React from "react";
import ErrorBoundary from "components/common/ErrorBoundary";
import AsyncComponent from "components/common/AsyncComponent";
import GestionDrawer from "components/pages/Gestion/GestionDrawer";
import GestionSubscriptionGate from "components/pages/Gestion/GestionSubscriptionGate";
import GestionAreaGuard from "components/pages/Gestion/GestionAreaGuard";

const AsyncPageWithDrawer = AsyncComponent(() => import("components/pages/PageWithDrawer"));

/**
 * Standard Gestión page shell: drawer + subscription payment gate + area guard + content.
 */
export function renderGestionPage(Content, { area } = {}) {
  return (props) => (
    <ErrorBoundary {...props}>
      <AsyncPageWithDrawer
        {...props}
        drawerComponent={<GestionDrawer />}
        enableDrawerCollapse
        content={
          <GestionSubscriptionGate>
            <GestionAreaGuard area={area}>
              <Content {...props} />
            </GestionAreaGuard>
          </GestionSubscriptionGate>
        }
      />
    </ErrorBoundary>
  );
}
